<template>
	<div id="app" class="app">
		
		<header>
			<div class="wordmark-wrap">
				<img src="./assets/bates-wordmark.svg">
				<h2>Post &amp; Print <span style="font-weight:normal">&mdash;</span> Shipping Request</h2>
				<time class="stamp">{{ date }}
					<span class="time">{{ timestamp }}</span>
				</time>
				<span class="job-number"></span>
			</div>
		</header>

		<PostPrintShippingRequest 
			:step.sync="step" 
			:message.sync="message" 
		/>

		<Message :message.sync="message" />
		
	</div>
</template>

<script>

import PostPrintShippingRequest from './components/PostPrintShippingRequest'
import Message from './components/Message';

export default {
	name: 'app',
	components: {
		PostPrintShippingRequest,
		Message,
	},
	data () {
		return {
			message: false,
			step: 1,
			timestamp: null
		};
	},
	watch: {
	},
	computed: {
		date () {
			var d = new Date();
			var dayName = this.getDayName(d);
			var month = this.getMonthName(d);
			return `${dayName}, ${month} ${d.getDate()}, ${d.getFullYear()}`
		},
	},
	methods: {
		setStep(step){
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
			this.step = step;
		},
		updateTime () {
			var d = new Date();
			var h = d.getHours();
			var meridian = 'am';
			if( h > 12) {
				h = h-12;
				meridian = 'pm';
			}
			var m = this.$options.filters.pad( d.getMinutes() );

			this.timestamp = `${h}:${m} ${meridian}`;
		}
	},
	created () {
		// update every 5 seconds is enough if we don't display the seconds
		window.setInterval( this.updateTime, 5000 );
	}
}
</script>

<style lang="scss" src="./assets/style.scss"></style>

<style lang="scss">

header {
	img {
		max-width: 200px;
	}
}
</style>
